import * as server from '../entries/pages/login/_page.server.ts.js';

export const index = 4;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/login/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/login/+page.server.ts";
export const imports = ["_app/immutable/nodes/4.DCn47Pxu.js","_app/immutable/chunks/Z8InAVTp.js","_app/immutable/chunks/BhyBrltq.js","_app/immutable/chunks/0gZYJLaf.js","_app/immutable/chunks/DYFTuOFP.js","_app/immutable/chunks/xihTtKlq.js"];
export const stylesheets = [];
export const fonts = [];
